import React, { useState, useRef, useEffect } from "react";

export const BOOKING_OPTIONS = [
  {
    label: "Pony Ride",
    type: "online" as const,
    href: "https://secure.activitybridge.com/book?activityid=15937",
  },
  {
    label: "Mini Horse Ride",
    type: "online" as const,
    href: "https://secure.activitybridge.com/book?activityid=15938",
  },
  {
    label: "Standard Ride",
    type: "online" as const,
    href: "https://secure.activitybridge.com/book?activityid=15939",
  },
  {
    label: "Romantic Picnic",
    type: "online" as const,
    href: "https://secure.activitybridge.com/book?activityid=15941",
  },
  {
    label: "Sunny Day Picnic",
    type: "online" as const,
    href: "https://secure.activitybridge.com/book?activityid=15940",
  },
  {
    label: "Stable Parties",
    type: "email" as const,
    href: "mailto:info@thestableshorserides.co.za?subject=Stable Party Enquiry",
  },
  {
    label: "Photoshoots",
    type: "email" as const,
    href: "mailto:info@thestableshorserides.co.za?subject=Horse Photoshoot Enquiry",
  },
  {
    label: "Proposals",
    type: "email" as const,
    href: "mailto:info@thestableshorserides.co.za?subject=Proposal Experience Enquiry",
  },
];

type Props = {
  triggerLabel?: string;
  triggerClassName?: string;
  dropUp?: boolean;
  align?: "left" | "right";
};

const BookingDropdown: React.FC<Props> = ({
  triggerLabel = "Book Now",
  triggerClassName = "",
  dropUp = false,
  align = "right",
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-2 ${triggerClassName}`}
      >
        {triggerLabel}
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div
          className={`absolute z-50 bg-white rounded-2xl shadow-2xl border border-stables-100 overflow-hidden min-w-[220px] ${
            dropUp ? "bottom-full mb-3" : "top-full mt-2"
          } ${align === "right" ? "right-0" : "left-0"}`}
        >
          <div className="p-2 space-y-0.5">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-stables-400 px-3 pt-1 pb-2">
              Online Booking
            </p>
            {BOOKING_OPTIONS.filter((o) => o.type === "online").map((option) => (
              <a
                key={option.label}
                href={option.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-stables-700 hover:bg-stables-50 hover:text-stables-900 transition-colors duration-150 text-sm font-medium group"
              >
                <span className="flex-1">{option.label}</span>
                <svg
                  className="w-3.5 h-3.5 text-stables-300 group-hover:text-stables-500 transition-colors"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            ))}

            <div className="border-t border-stables-100 mt-1 pt-1">
              <p className="text-[10px] font-semibold uppercase tracking-widest text-stables-400 px-3 pt-1 pb-2">
                Enquire via Email
              </p>
              {BOOKING_OPTIONS.filter((o) => o.type === "email").map((option) => (
                <a
                  key={option.label}
                  href={option.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-stables-700 hover:bg-earth-50 hover:text-stables-900 transition-colors duration-150 text-sm font-medium group"
                >
                  <span className="flex-1">{option.label}</span>
                  <svg
                    className="w-3.5 h-3.5 text-stables-300 group-hover:text-earth-500 transition-colors"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingDropdown;
